// src/api/positionSettingsApi.js

import axios from 'axios';
import apiClient from './apiClient';

// Базовый клиент, унаследованный от apiClient (с вашими настройками, URL, credentials и т.д.)
const inventoryClient = apiClient('');

const positionSettingsApi = {
    /**
     * Получить все записи positionSettings
     * GET /positionSettings
     */
    async getAllPositionSettings() {
        try {
            const response = await inventoryClient.get('/positionSettings');
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении всех настроек позиций:', error);
            throw error;
        }
    },

    /**
     * Получить одну запись по ID
     * GET /positionSettings/:id
     * @param {number} id
     */
    async getPositionSettingById(id) {
        try {
            const response = await inventoryClient.get(`/positionSettings/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении настройки позиций с ID ${id}:`, error);
            throw error;
        }
    },

    /**
     * Создать новую запись positionSettings
     * POST /positionSettings
     * @param {Object} data — JSON с полями:
     *   {
     *     gemId: number,
     *     number: number,
     *     name: string,
     *     minParticipantsCount: number,
     *     minPrizePlacesCount: number,
     *     promoType: string,        // из enum: 'onlyCrystals' | 'crystalsAndCrypto' | 'cryptoOnly'
     *     defaultBudget: number,
     *     defaultTokenType: string, // например 'USDT' или 'CRYSTAL'
     *     presets: [ { win: number, budget_percent: number }, ... ]
     *   }
     */
    async createPositionSetting(data) {
        try {
            const response = await inventoryClient.post('/positionSettings', data);
            return response.data;
        } catch (error) {
            console.error('Ошибка при создании настройки позиций:', error);
            throw error;
        }
    },

    /**
     * Обновить существующую запись positionSettings
     * PATCH /positionSettings/:id
     * @param {number} id
     * @param {Object} data — JSON с любыми полями из CreatePositionSettingDto
     */
    async updatePositionSetting(id, data) {
        try {
            const response = await inventoryClient.patch(`/positionSettings/${id}`, data);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при обновлении настройки позиций с ID ${id}:`, error);
            throw error;
        }
    },

    /**
     * Удалить запись positionSettings
     * DELETE /positionSettings/:id
     * @param {number} id
     */
    async deletePositionSetting(id) {
        try {
            const response = await inventoryClient.delete(`/positionSettings/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при удалении настройки позиций с ID ${id}:`, error);
            throw error;
        }
    },
    /**
     * Получить все настройки позиций по promoType
     * GET /positionSettings/type/:promoType
     * @param {'onlyCrystals' | 'crystalsAndCrypto' | 'cryptoOnly'} promoType
     */
    async getPositionSettingsByPromoType(promoType) {
        try {
            const response = await inventoryClient.get(`/positionSettings/type/${promoType}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении настроек позиций для promoType "${promoType}":`, error);
            throw error;
        }
    },

    /**
     * (Опционально) Получить все записи positionSettings, отсортированные по gemId
     * GET /positionSettings/byGem/:gemId
     * @param {number} gemId
     */
    async getPositionSettingsByGemId(gemId) {
        try {
            const response = await inventoryClient.get(`/positionSettings/byGem/${gemId}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении настроек позиций для gemId ${gemId}:`, error);
            throw error;
        }
    }
};

export default positionSettingsApi;
